<template>
	<div class="instruction-item tw-p-4 custom-fade-in">
		<div class="tw-flex tw-justify-between tw-items-center tw-gap-4">
			<span class="title"><b>{{ item.name }}</b></span>
		</div>
		<p-horizontal-divider mx="-1rem" my="1rem" />
		<section class="">
			<v-chip
				class="tags"
				v-for="(career, index) in item.career"
				:key="index">
			{{ career }}</v-chip>
		</section>
	</div>
</template>

<script>
import PButton from '@/modules/shared/components/ui/p-button';
import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';

function created() {
}

function setCareer(careers) {
	this.$emit('career-select', careers);
}

export default {
	name: 'InstructionItem',
	created,
	props: ['item', 'selectData', 'careerReturn', 'index'],
	components: { PButton, PHorizontalDivider },
	methods: {
		setCareer,
	},
};
</script>

<style lang="scss">
.instruction-item {
	border: 1px solid var(--app-color-gray);
	border-radius: 10px;
	.title {
		color: map-get($colors, gray-sidebar);
		font-size: 16px !important;
	}
}
.tags {
	border: 1px solid color(orange-dark);
	color: color(orange-light) !important;
	background-color: color(orange-white) !important;
	font-family: font(bold);
}
</style>



// WEBPACK FOOTER //
// src/modules/job-profile/components/content/p-instruction-item.vue